<div class="overall-rating-module">
    <div class="title">{{ 'lang.reporting.overallRating' | translate }}</div>
    <div class="overall-rating-statistic row d-flex justify-content-around">
      <div  *ngIf="overallRating.overallExcludeSelf && overallRating.overallExcludeSelf>0">
        <div class="line-break">{{ 'lang.reporting.overallExcludeSelf' | translate }}</div>
        <span class="overall-excluse-self">{{ getRate(overallRating.overallExcludeSelf) }}</span>
        <span class="common-denominator">/{{ overallRating.maxScaleValue }}</span>
      </div>
      <div *ngIf="overallRating.self && overallRating.self>0">
        <div class="line-break">{{ 'lang.reporting.self' | translate }} </div>
        <span class="self-assesment">{{ getRate(overallRating.self) }}</span>
        <span class="common-denominator">/{{ overallRating.maxScaleValue }}</span>
      </div>
      <div *ngIf="overallRating.comparisonGroup && overallRating.comparisonGroup>0">
        <div class="line-break">{{ 'lang.reporting.comparisonGroup' | translate }}</div>
        <span class="comparison-group">{{ getRate(overallRating.comparisonGroup) }}</span>
        <span class="common-denominator">/{{ overallRating.maxScaleValue }}</span>
      </div>
    </div>
    <div class="overall-rating-bar line-canvas">
        <canvas id="myChart" [width]="pieWidth"></canvas>
        <img hidden id="lineChart"/>
    </div>
    <div class="overall-rating-description">
      {{ scaleDescription }}
    </div>
  </div>